import WatchlistService from 'src/modules/watchlist/watchlistService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'WATCHLIST_VIEW';

const watchlistViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistViewActions.FIND_STARTED,
      });

      const record = await WatchlistService.find(id, 'tableMode');

      dispatch({
        type: watchlistViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: watchlistViewActions.FIND_ERROR,
      });

      getHistory().push('/watchlist');
    }
  },
};

export default watchlistViewActions;
